module.exports = __webpack_public_path__ + "static/media/reactImage2.a17e1b88.PNG";